import mixpanel from "mixpanel-browser"
import { SIGN_UP_EVENTS } from "."

export function start() {
  mixpanel.track(SIGN_UP_EVENTS.START)
}
